import { jsx as e } from "react/jsx-runtime";
import { headingVariants as t } from "./Heading.variants.js";
const d = t.definition().defaultVariants, c = ({
  as: a,
  children: i,
  className: n,
  size: o = d.size,
  ...r
}) => {
  const { root: s } = t;
  return /* @__PURE__ */ e(a, { className: s({ className: n, size: o }), ...r, children: i });
};
export {
  c as Heading
};
